import { gtm_Key } from '../../../constants'
import TagManager from 'react-gtm-module'
export  function gtmIntialize(){
    const tagManagerArgs = {
        gtmId: gtm_Key
    }
    TagManager.initialize(tagManagerArgs)
}
export function triggerGtmAction (action){
        if(action !='undefined' && action != null && action != "" ) {
            const tagManagerArgs = {
                dataLayer: {
                    event: 'Echo',
                    action: action,
                },
            } 
            TagManager.dataLayer(tagManagerArgs)

        }
}